import gql from "graphql-tag";

export default gql`
  mutation updateCreditCommentary($id: String!, $updates: [UpdateInput!]!) {
    updateCreditCommentary(id: $id, updates: $updates) {
      __typename
      id
      friendly_entity_id
      subject_type
      subject_id
      effective_time
      category
      detail
      current
      user
    }
  }
`;
